import { render, staticRenderFns } from "./ModuleBlockSelection.vue?vue&type=template&id=a1479720&scoped=true"
import script from "./ModuleBlockSelection.vue?vue&type=script&lang=js"
export * from "./ModuleBlockSelection.vue?vue&type=script&lang=js"
import style0 from "./ModuleBlockSelection.vue?vue&type=style&index=0&id=a1479720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1479720",
  null
  
)

export default component.exports